import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';

// Handles the redirect back from Cognito Hosted UI after Apple Sign In.
// Must NOT be inside a PrivateRoute — accessible regardless of auth state.
export default function OAuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn') {
        navigate('/', { replace: true });
      }
      if (payload.event === 'signIn_failure') {
        navigate('/login', { replace: true });
      }
    });

    // Fallback: if Hub never fires (e.g. already signed in), redirect after 5s
    const timeout = setTimeout(() => navigate('/login', { replace: true }), 5000);

    return () => {
      unsubscribe();
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <div className="app-loading">
      <div className="loading-spinner" />
    </div>
  );
}
